import { inject } from '@angular/core';
import { Route } from '@angular/router';
import { BrownfieldFallbackComponent } from 'brownfield-bridge';
import { EntitlementsService } from 'entitlements';

export const adminRoutes: Route = {
  path: 'admin',
  canActivate: [
    () =>
      inject(EntitlementsService).canActivateWithPermissions({
        requireAdmin: true,
        id: 'admin',
      }),
  ],
  children: [
    {
      path: 'settings',
      loadChildren: () =>
        import('@features/admin-settings').then((m) => m.AdminSettingsModule),
    },
    {
      path: 'switch-user',
      loadChildren: () =>
        import('session-assumption').then((m) => m.SessionAssuptionModule),
    },
    {
      path: 'request-builder',
      loadChildren: () =>
        import('@features/request-state-manager-builder').then(
          (m) => m.requestStatemanagerBuilderRoutes,
        ),
    },
    {
      path: '**',
      component: BrownfieldFallbackComponent,
      data: {
        brownfieldRootUrlEnvKey: 'ADEX_BROWNFIELD_URL',
        brownfieldPathPrefix: 'adex/',
      },
    },
  ],
};
